import { Linking } from 'react-native';

import { PressableCell } from '../../../components/PressableCell';

interface Props {
	email?: string | null;
}

export const EmailCell = ({ email }: Props) => {
	return (
		<PressableCell
			text={email}
			onPress={email ? () => Linking.openURL(`mailto:${email}`) : undefined}
		/>
	);
};
